export enum AvatarSizes {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  XLARGE = "x-large",
  XXLARGE = "xx-large",
}

export type AvatarTypeProps = {
  size: `${AvatarSizes}` | number;
  alt?: string;
  square?: boolean;
  hash?: string | any;
  image?: string | any;
  id?: string;
};
